import { PageHeader, UsersTable, useAuth } from "@nexys/user-management-web";
import { Navigate, useNavigate } from "react-router-dom";

export const UsersPage = () => {
  const { hasUserRole } = useAuth();
  const navigate = useNavigate();
  if (!hasUserRole("superadmin", "useradmin")) {
    // Non-admin users land on the dashboard if they navigate here
    // directly. The sidebar already hides the entry.
    return <Navigate to="/" replace />;
  }

  const superadmin = hasUserRole("superadmin");
  return (
    <div className="grid gap-6">
      <PageHeader
        title="Users"
        description="Browse, search and manage every user in the system."
      />
      <UsersTable
        allowRoleChange={superadmin}
        allowCreate={superadmin}
        onOpenUser={(u) => navigate(`/users/${u.id}`)}
      />
    </div>
  );
};
